<template>
  <BrToolBar @search="buscar" :configFilter="configFilter" :addlFilter="addlFilter">
    <BrModalCadastro />
  </BrToolBar>
</template>

<script>
/**
 * MIXIN
 */
import toolbar from '@/views/mixins/toolbar'

export default {
  name: 'TollbarDespesas',
  mixins: [toolbar],
  components: { 
    BrModalCadastro: () => import('./modalCadastro'),
    BrToolBar: () => import('@/views/components/toolbar')
  }
}
</script>